import * as React from "react";
import { useReducer, useEffect } from "react";
import { Provider, connect } from "react-redux";
import { bindActionCreators } from 'redux';
import InfiniteScroll from 'react-infinite-scroller';
import { FacetResult } from "../Models/FacetResult";
import { ChapterArticle } from "../Models/ChapterArticle";
import * as  ChaptersBlogListingStore from '../store/ChaptersBlogListing';
import { ApplicationState, store } from '../store';


export type SearchFilter = {
    Keywords: string;
    Category: string;
    //Chapter: string;
    YearMonth: string;
    SortByField: string;
    SortASC?: boolean;
    Path: string;
}

type ChaptersListingResultState = {

    items: ChapterArticle[];
    totalItems: number;
    isNoResults: boolean;
    isLoading: boolean;
    canLoadMore: boolean;
    searchFilter: SearchFilter;
}

const initialState: ChaptersListingResultState = {
    items: [],
    totalItems: 0,
    isNoResults: false,
    isLoading: false,
    canLoadMore: false,
    searchFilter: undefined
}

const ChapterBlogListingResultInner = (props: {
    //searchFilter: SearchFilter;
    //searchByCategory: (categoryId: string) => void;

    store: ChaptersBlogListingStore.IState;
    storeActions: typeof ChaptersBlogListingStore.actionCreators;

}) => {

    const [state, setState] = useReducer(
        (prevState: ChaptersListingResultState, Chapterstate: Partial<ChaptersListingResultState>) => ({ ...prevState, ...Chapterstate }),
        initialState
    );

    const search = () => {
        if (!props.store.filter)
            return;

        setState({ isLoading: true, canLoadMore: false });

        serviceCall(props.store.filter, 0)
            .then(x =>
                setState({
                    items: x.items,
                    isNoResults: x.items.length == 0,
                    canLoadMore: x.totalItems > x.items.length,
                    isLoading: false
                })
            );

    }

    const loadMore = () => {

        setState({ isLoading: true, canLoadMore: false });

        serviceCall(props.store.filter, state.items.length)
            .then(x => {

                let updatedItems = state.items.concat(x.items);

                setState({
                    items: updatedItems,
                    canLoadMore: x.totalItems > updatedItems.length,
                    isLoading: false
                });
            }
            );
    }

    const serviceCall = (sf: SearchFilter, offset: number): Promise<FacetResult<ChapterArticle>> => {

        const payload = { ...sf, offset, pageSize: 10 };

        return fetch('/cpaapi/chapterblog', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        }).then(res => res.json());

    };


    // update on new search filter
    useEffect(() => {

        // conso
        console.log('new props results, ', props.store.filter);

        search();

    }, [props.store.filter]);

    return <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={state.canLoadMore && !state.isLoading}
        className="results-wrapper"
    >
        {state.items.map(x => <ChaptersListingItem key={x.NodeId} item={x} searchByCategory={props.storeActions.setCategory} />)}
    </InfiniteScroll>
}

const ChaptersListingItem = (props: {
    item: ChapterArticle;
    searchByCategory: (categoryId: string) => void;
}) => {

    const { item } = props;

    return <div className="chapters-listing-item">
        {item.Thumbnail && item.Thumbnail.length > 0 && <a href={item.Url} className="img-container float-right">
            <img src={item.Thumbnail} alt={item.ThumbnailAlt} className="img-fluid" />
        </a>}
        <div className="event-body">
            <div>
                <span hidden={!item.Category} className="category cursor-pointer" style={{ backgroundColor: (item.Category ? item.Category.BackgroundColor : '#fff'), color: (item.Category ? item.Category.TextColor : '#000') }}
                    onClick={() => { props.searchByCategory(item.CategoryId) }}
                >{item.Category ? item.Category.Name : ''}</span>
                <span className="audience">{item.Media}</span>
            </div>
            <a href={item.Url} className="event-title">{item.Title}</a>
            <div className="summary" dangerouslySetInnerHTML={{ __html: item.Summary }}></div>
            <div className="event-bottom">
                <span className="author">By <b>{item.Author}</b></span>
                <span className="event-date">{item.DateAsString}</span>
                <div className="chapter-name">{item.Chapter}</div>
                {/*
                <span className="addthis_toolbox d-inline" data-addthis-url={props.item.Url} data-addthis-title={props.item.Title}>
                    <span className="custom_images">
                        <a className="addthis_button_more"><span className="btn-share">Share</span></a>
                    </span>
                </span>
                */}
            </div>
        </div>

        <div className="clearfix"></div>
    </div>;
}


const ConnectedChapterBlogListingResult = connect(
    (state: ApplicationState) => ({ store: state.chaptersBlogListing }),
    (dispatch, getState) => ({
        storeActions: bindActionCreators(ChaptersBlogListingStore.actionCreators, dispatch), // Selects which action creators are merged into the component's props
    })
)(ChapterBlogListingResultInner);

class ChapterBlogListingResult extends React.Component {
    render() {
        return (
            <Provider store={store}><ConnectedChapterBlogListingResult {...this.props} ></ConnectedChapterBlogListingResult></Provider>
        )
    }
}

export default ChapterBlogListingResult;
